<template>
    <div class="search-main" v-bind:class="{'fixed': appScroll}">
        <div class="search-main__box-container">
        </div>
        <div class="container">
            <div class="search-main__header">
              <img class="header__bg" src="static/img/header.svg">
              <p class="search-main__desc">
                {{ $lang.search.main.desc }}
              </p>
            </div>
            <div class="search-main__box">
                <div class="search-main__form-icon">
                  <img src="static/img/newspaper.svg">
                </div>
                <search-form></search-form>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchForm from './../Search/SearchForm'
    import { mapGetters } from 'vuex'

    export default {
        name: 'searchBlockMain',
        components: {
            'search-form': SearchForm
        },
        computed: {
          ...mapGetters({
            appScroll: 'GET_APP_SCROLL'
          })
        }
    }
</script>



// WEBPACK FOOTER //
// SearchBlockMain.vue?0651f8d8